import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from '@/i18n/en.js';
import fr from '@/i18n/fr.js';

Vue.use(VueI18n);

let messages = {};
messages = { ...messages, en, fr };

/* La langue est une valeur EXTERNE : elle arrive par `?lang=` (bascule depuis la console app)
 * et atterrit dans localStorage. `app` construit ce paramètre par concaténation depuis sa
 * propre clé `locale` — absente, elle produit la chaîne "null", qui est truthy et traversait
 * donc `|| 'en'`. VueI18n l'acceptait, puis `toLocaleString("null")` levait
 * « RangeError: Invalid language tag: null » et tuait la computed des compteurs d'onglets.
 * On ne fait plus confiance à ce qui est stocké : seule une langue connue est retenue. */
export const LANGUES_SUPPORTEES = ['en', 'fr'];
export const LANGUE_PAR_DEFAUT = 'en';

export function normaliserLangue(valeur) {
  return LANGUES_SUPPORTEES.includes(valeur) ? valeur : LANGUE_PAR_DEFAUT;
}

const lang = normaliserLangue(localStorage.getItem('language'));

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: lang, // set locale
    messages // set locale messages
});

export default i18n;